import React from 'react'
import DashboardComp from '../../components/dashboard/DashboardComp'

const DashboardScreen = () => {
    return (
        <>
            <DashboardComp />
        </>
    )
}

export default DashboardScreen